import { Box, Button, LinearProgress, Skeleton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Theme, Typography, } from "@mui/material";
import { linearProgressClasses } from '@mui/material/LinearProgress';
import { DownwardIcon, UpwardIcon } from "../../../assets/SvgIcons";
import { ErrorText } from "../chart/CustomeLineChart";

export const CompaniesTable = ({ data, showAll, onShowAllToggle, loading }: any) => {

    return (

        <TableContainer>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell sx={(theme: Theme) => (
                            {
                                color: theme.palette.text.secondary,
                                ...theme.typography.subtitle_500,
                                fontFamily: theme.typography.fontFamily,
                                padding: 0,

                            }
                        )}>{loading ? <Skeleton animation="wave" /> : "Company Name"}</TableCell>
                        <TableCell sx={(theme: Theme) => (
                            {
                                color: theme.palette.text.secondary,
                                ...theme.typography.subtitle_500,
                                fontFamily: theme.typography.fontFamily,
                            })}>{loading ? <Skeleton animation="wave" /> : "Allocation"}</TableCell>
                        <TableCell />
                    </TableRow>
                </TableHead>
                <TableBody>
                    {data?.length ? data?.map((row: any, index: number) => (
                        <TableRow key={index}>
                            <TableCell sx={(theme: Theme) => (
                                {
                                    ...theme.typography.body_500,
                                    fontFamily: theme.typography.fontFamily,
                                    color: theme.palette.text.primary,
                                    '&:hover': {
                                        color: theme.palette.primary[500]
                                    },
                                    padding: 0
                                })}>
                                {loading ? <Skeleton animation="wave" /> : (row?.companyName ?? "")}
                            </TableCell>
                            <TableCell sx={(theme: Theme) => (
                                {
                                    color: theme.palette.text.primary,
                                    ...theme.typography.body_500,
                                    fontFamily: theme.typography.fontFamily,
                                })}>{loading ? <Skeleton animation="wave" /> : `${!Number.isNaN(Number(row?.allocation ?? 0)) ?
                                    Math.round((row?.allocation ?? 0) * 100) / 100 : '0'}%`}
                            </TableCell>
                            <TableCell sx={{ width: '50%' }}>
                                {loading ? <Skeleton animation="wave" /> : <LinearProgress variant="determinate" value={row.allocation} sx={(theme: Theme) => (
                                    { background: '#D9D9D9', borderRadius: '15px', [`&.${linearProgressClasses.colorPrimary}`]: { background: 'D9D9D9' }, [`& .${linearProgressClasses.bar}`]: { background: theme.palette.primary[800] } }
                                )} />}
                            </TableCell>
                        </TableRow>
                    )) : <Box sx={{ mt: '20px', textAlign: 'center' }}>
                        {loading ?
                            <Skeleton animation="wave" />
                            :
                            <TableRow sx={{ textAlign: 'center' }}>
                                <ErrorText />
                            </TableRow>
                        }
                    </Box>}
                </TableBody>
            </Table>
            {loading ? '' : data?.length > 4 && (
                <Button variant="outlined" sx={{
                    padding: '7px 0px', border: 'none', mt: '15px',
                    '&:hover': {
                        border: 'none',
                        background: 'transparent'
                    },
                }} onClick={onShowAllToggle}>
                    <Typography component={'span'} sx={(theme: Theme) => ({
                        color: theme.palette.primary[500],
                        border: 'none',
                        mr: '3px',
                        cursor: 'pointer'
                    })}>{showAll ? 'Show less' : 'Show all'}</Typography>
                    {showAll ? <UpwardIcon /> : <DownwardIcon />}
                </Button>
            )}
        </TableContainer>
    )
};